import { DEFAULT_LOCALE } from '@shared/*';

export const locales = ['en-US', 'cs-CZ', 'hu-HU', 'nl-NL', 'nl-BE', 'pl-PL', 'es-MX', 'de-LU', 'de-DE', 'fr-BE', 'fr-LU'];

export function parseLocaleOrUseDefault(locale: string): string {
  if (locales.includes(locale)) { // 4-letter locale
    return locale;
  }

  const languageMatch = locales.find((l) => l.startsWith(locale /* 2-letter locale */));
  return languageMatch || DEFAULT_LOCALE;
}
